import isFunction from 'lodash/isFunction';
import {createEventHandler} from 'recompose';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/pluck';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/withLatestFrom';


export function createFieldState(props$) {
  const {
    handler: onChange,
    stream: change$,
  } = createEventHandler();

  const isEditing$ = props$
    .pluck('isEditing')
    .distinctUntilChanged();

  const value$ = props$
    .pluck('value')
    .distinctUntilChanged();

  const state$ = isEditing$
    .combineLatest(
      value$,
      (isEditing, value) => {
        if (!isEditing) {
          return Observable.of({value, error: null});
        } else {
          return createChangeState(props$, change$)(value);
        }
      })
    .switchMap(state$ => state$);

  return {
    onChange,
    state$,
  };
}

function createChangeState(props$, change$) {
  return prevValue =>
    change$
      .withLatestFrom(props$)
      .map(([nextValue, props]) => {
        const error = getError(nextValue, props.constraints);
        let nextState;
        let customValidation;
        if (isFunction(props.onValidate) && (customValidation = props.onValidate({
          prev: prevValue,
          next: nextValue,
        }))) {
          nextState = {
            value: customValidation.value,
            error: customValidation.error,
          };
        } else if (error) {
          nextState = {
            value: nextValue,
            error: error,
          };
        } else if (prevValue !== nextValue) {
          nextState = {
            value: nextValue,
            error: null,
          };
        } else {
          nextState = {
            value: prevValue,
            error: null,
          };
        }

        if (props.onChange) {
          props.onChange({
            target: {
              value: nextState.value,
              isValid: !nextState.error,
            },
          });
        }

        return nextState;
      })
      .startWith({
        value: prevValue,
        error: null,
      })
      .scan((acc, curr) => ({
        ...acc,
        ...curr,
      }));
}

function getError(nextValue, constraints) {
  if (!constraints) {
    return null;

  } else if (!nextValue && !constraints.nullable) {
    return {
      code: 'default.select.none.message',
    };

  } else {
    return null;
  }
}

export function getErrorValue(props, state) {
  if (!props.isEditing) {
    return null;
  } else if (props.error) {
    return props.error;
  } else if (state.error) {
    return state.error;
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/forms/utils.js